import { firestore } from '../../utilities/firebase'
import getKitByKitId from './internal'

export default getKitByKitId(firestore)



// WEBPACK FOOTER //
// ./src/dataservices/getKitByKitId/index.js